module.exports = __webpack_public_path__ + "img/3e998cc.png";